module.exports = __webpack_public_path__ + "static/media/downArrow.be0f2510.svg";